import { bookingInquiryApis } from '@apis/dashboard/bookingInquiryApis';
import { dashboardInvoiceApis } from '@apis/next/invoiceApis';
import { dashboardPreAlertApis } from '@apis/next/preAlertApis';
import { validateContactZipcode } from '@hooks/helpers/validateContactZipcode';
import { useMutation } from '@hooks/useMutation';
import { PatchBookingInquiry } from '@models/BookingInquiry';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchBookingInquiry = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchBookingInquiry) => {
      if (body.receiver) {
        await validateContactZipcode({ ...body.receiver, contact_type: 'consignee' });
      }

      const response = await bookingInquiryApis.patch('/dashboard/booking-inquiry/{d2d_no}/', {
        path: { d2d_no },
        body,
      });

      if (response[400]) {
        throw new FormError('PatchBookingInquiry', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2d_no}/`]);

        queryClient.invalidateQueries(
          dashboardPreAlertApis.getKeyByPath('get', '/dashboard/pre-alert/:d2d_no', {
            params: { d2d_no },
          }),
        );

        // This is required,
        // because changing
        // 1. `booking_inquiry.trading_agency_payer`
        // 2. `booking_inquiry.use_trading_agency`
        // will possibly refresh `中国貿易代行サービス料` of `invoice_detail`.
        queryClient.invalidateQueries(
          dashboardInvoiceApis.getKeyByPath(
            'get',
            '/dashboard/booking-inquiry/:d2d_no/invoice-detail',
          ),
        );
        queryClient.invalidateQueries(
          dashboardInvoiceApis.getKeyByPath('get', '/dashboard/invoice-detail/:id'),
        );
      },
    },
  );
};
